import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ '@/views/searchView.component.vue')
    },
   
    {
      path:'/stats',
      component: () => import(/* webpackChunkName: "statistics" */ '@/views/stats/index.vue'),
      meta: {
        requiresAuth: true
      },
      children:[
          {
            name:'statFormNew',
            path: 'form-new/:categoryId/:userId',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/stats/statsFormView.vue')
          },
          {
            name:'statFormView',
            path: 'form/:id/:userId/:categoryId',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/stats/statsFormView.vue')
          }
      ],
    },
    {
      path:'/stats-dashboard',
      name: "StatsDashboard",
      component: () => import(/* webpackChunkName: "statistics" */ '@/views/stats/dashboard.vue'),
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/admin',
      name: '',
      component: () => import(/* webpackChunkName: "editor" */ '@/views/editor/index.vue'),
      children:[
        {
          path: 'out-of-office',
          name: 'OutofOffice',
          component: () => import(/* webpackChunkName: "editor" */ '@/views/editor/outofoffices.component.vue')
        },
      ]
    },
    {
      path:'/coa-transcript-request',
      name: 'transcriptRequest',
      component: () => import(/* webpackChunkName: "forThePublick" */ '@/components/transcripts/publicRequestForm.component.vue'),
    },
    {
      path:'/incoming-transcripts',
      name: 'transcriptsLists',
      meta: {
        requiresAuth: true
       },
      component: () => import(/* webpackChunkName: "transcriptsManagement" */ '@/views/transcriptsList.component.vue'),
      
      children:[
        {
          name:'itemView',
          path:':id',
          component: () => import(/* webpackChunkName: "transcriptsManagement" */'@/views/transcripts/request.vue')
        }
      ]
    },
    {
      path:'/transcripts',
      name:'transcripts',
      meta: {
        requiresAuth: true
       },
      component: () => import(/* webpackChunkName: "transcriptsManagement" */ '@/views/transcripts.component.vue'),
      children: [
        {
          name:'new_entry',
          path:'transcript/new',
          component: () => import(/* webpackChunkName: "transcriptsManagement" */ '@/components/transcripts/transcriptForm.component'),
        },
        {
          name:'view_entry',
          path:'transcript/view/:id',
          component: () => import(/* webpackChunkName: "transcriptsManagement" */ '@/components/transcripts/transcriptView.component'),
        },
      ]
    },
    {
      path:'/library',
      name:'library',
      component: () => import(/* webpackChunkName: "library" */ '@/views/library.vue'),
      children: [
        {
          name:'new_item',
          path:'new',
          component: () => import(/* webpackChunkName: "library" */ '@/components/library/newEntry.component'),
        },
        {
          name:'view_item',
          path:'view/:id',
          component: () => import(/* webpackChunkName: "library" */ '@/components/library/newEntry.component'),
        },
        {
          path:'/book/loans',
          name:'loans',
          component: () => import(/* webpackChunkName: "library" */ '@/views/library.vue'),
        },
      ]
    },
    {
      name:'sol',
      path:'/sol',
      component: () => import(/* webpackChunkName: "evluationsManagement" */ '@/components/hreval/judgesEvaluation.component'),
    },
    {
      path:'/evaluations',
      name:'evaluations',
      meta: {
        requiresAuth: true
       },
      component: () => import(/* webpackChunkName: "evluationsManagement" */ '@/views/evaluations.component.vue'),
      children: [
        {
          name:'new_eval',
          path:'evaluations/new',
          component: () => import(/* webpackChunkName: "evluationsManagement" */ '@/components/hreval/judgesEvaluation.component'),
        },
        {
          name:'view_eval',
          path:'evaluations/view/:id',
          component: () => import(/* webpackChunkName: "evluationsManagement" */ '@/components/hreval/judgesEvaluation.component'),
        },
      ]
    },
    {
      path:'/records',
      name:'records',
      component: () => import(/* webpackChunkName: "recordsManagement" */ '@/views/records.component.vue'),
      meta: {
        requiresAuth: true
       },
      children:[   
        {
          name:'new_record',
          path:'record/new',
          component: () => import(/* webpackChunkName: "recordsManagement" */ '@/components/records/recordForm.component'),
        },
        {
          name:'view_record',
          path:'record/view/:id',
          component: () => import(/* webpackChunkName: "recordsManagement" */ '@/components/records/recordView.component'),
        }
      ]
      
    },
    {
      path: '/reports/',
      name: 'reportsView',
      component: () => import(/* webpackChunkName: "recordsManagement" */ '@/views/records/reports')
    },
    {
      path:'/login',
      name:'login',
      component: () => import(/* webpackChunkName: "authComponent" */ '@/views/login.component.vue')
    },
    {
      path: '/category/:slug',
      name: 'category',
      component: () => import(/* webpackChunkName: "categories" */ '@/views/categoryView.component.vue')
    },
    {
      path:'/article/:slug',
      name:'article',
      component: ()=> import(/* webpackChunkName: "articles" */ '@/views/articleView.component.vue')
    }
  ],
  scrollBehavior() {
       return { x: 0, y: 0 };
   },
})
